const DEFAULT_WIDTH = 560;
const DEFAULT_HEIGHT = 760;

export const openPopupWindow = (url, { width = DEFAULT_WIDTH, height = DEFAULT_HEIGHT } = {}) => {
    if (!url) return null;

    const popupWidth = Math.round(Math.min(width, window.outerWidth));
    const popupHeight = Math.round(Math.min(height, window.outerHeight));
    const left = Math.round(window.screenX + (window.outerWidth - popupWidth) / 2);
    const top = Math.round(window.screenY + (window.outerHeight - popupHeight) / 2);

    const features = [
        'popup=yes',
        `width=${popupWidth}`,
        `height=${popupHeight}`,
        `left=${left}`,
        `top=${top}`,
        'scrollbars=yes',
        'resizable=yes',
    ].join(',');

    const popup = window.open('', '_blank', features);
    if (!popup) return null;

    popup.opener = null;
    popup.location.replace(url);
    popup.focus();

    return popup;
};
